import React, { useState } from 'react';
import { SelectBox, TextBox } from 'devextreme-react';
import ModelSelector from './ModelSelector';
import { IconButton } from '@material-ui/core';
import addIcon from '../../../../../images/iconoAdd.svg';
import clearIcon from '../../../../../images/clear.png';

function InputWrapper(props) {
  const { classes, label } = props;
  return (
    <div className="dx-field">
      <label className={classes.label}>{label}</label>
      <div style={{ width: '100%' }} className="dx-field-value">
        {props.children}
      </div>
    </div>
  );
}

export default function BrandSelector(props) {
  const [brandEmail, setBrandEmail] = useState();
  const [filteredBrandModels, setFilteredBrandModels] = useState([]);

  function modelsSelectionContent(brandModels) {
    return brandModels.map((obj, i) => {
      return (
        <ModelSelector
          key={`model-selector-${i}`}
          models={filteredBrandModels}
          brandIndex={props.brandIndex}
          modelIndex={i}
          data={obj}
          classes={props.classes}
          removeModel={props.removeModel}
          handleModelChange={props.handleModelChange}
        ></ModelSelector>
      );
    });
  }

  function onChangeBrand(brandId) {
    const filteredModels = props.masterModels.filter((item) => item.brandId === brandId);
    setFilteredBrandModels(filteredModels);
    props.handleBrandChange(props.brandIndex, 'brandId', brandId);

    // const filteredbrand = props.masterBrands.filter((item) => item.brandId === brandId)[0];
    // onChangeBrandEmail(filteredbrand.email)
  }

  function onChangeBrandEmail(email) {
    setBrandEmail(email)
    props.handleBrandChange(props.brandIndex, 'brandEmail', email);
  }

  return (
    <div style={{ border: '1px solid white', padding: '0 4px 4px 4px', marginBottom: 5, backgroundColor: '#31444a' }}>
      <InputWrapper classes={props.classes} label={'Montadora'}>
        <div style={{ display: 'flex' }}>
          <SelectBox
            key={`brand-${props.brandIndex}`}
            value={props.data?.brandId}
            valueExpr={'brandId'}
            displayExpr="brandName"
            onValueChanged={(e) => onChangeBrand(e.value)}
            placeholder=""
            dataSource={props.masterBrands}
            height={25}
            width={230}
          ></SelectBox>
          <IconButton onClick={(e) => props.removeBrand(props.brandIndex)} style={{ backgroundColor: '#d47f7f', padding: 2, marginLeft: 5 }}>
            <img src={clearIcon} alt="Remover montadora" title={'Remover montadora'} width={20} />
          </IconButton>
        </div>
      </InputWrapper>

      {/* {props.data?.brandId && (
        <InputWrapper classes={props.classes} label={'E-mail da montadora'}>
          <TextBox
            mode="email"
            key={'brandEmail'}
            name="brandEmail"
            value={brandEmail}
            onValueChanged={(e) => onChangeBrandEmail(e.value)}
            className={props.classes.controlers}
            height={25}
          ></TextBox>
        </InputWrapper>
      )} */}

      <div onClick={(e) => props.addNewModel(props.brandIndex)} style={{ color: 'white', cursor: 'pointer' }}>
        <IconButton style={{ backgroundColor: 'white', padding: 2, marginRight: 5, height: 20, width: 20 }}>
          <img src={addIcon} alt="Adicionar modelo" title={'Adicionar modelo'} width={20} />
        </IconButton>
        <spa>Adicionar modelo</spa>
      </div>

      {modelsSelectionContent(props.data?.models)}
    </div>
  );
}
